import Highlight from '@tiptap/extension-highlight'

export const Highlights =  Highlight.configure({ multicolor: true })